import React, { useEffect, useState } from 'react'
import { BsCheck2, BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/Overview.module.css"
import common from "./Styles/Common.module.css"
import {BiChevronRight, BiDownload} from "react-icons/bi"
import { useNavigate } from 'react-router-dom'
import { FiEdit } from 'react-icons/fi'
import { HiOutlineDocumentText, HiOutlineUsers } from 'react-icons/hi'
import { RiDeleteBin6Line } from 'react-icons/ri'
import Input from '../../Components/Input';
import CustomDropdown from '../../Components/CustomDropdown'

export default function Overview() {
  const navigate = useNavigate()
  const [items, setItems] = useState(['Lead Initiated','Basic Details','Quiz','Space Requirement','Plan Selection','Layout Plan','Lead Closed']) 
  const [tasks, setTasks] = useState(['Meeting','Phone Call','Follow Up','Phone Call'])

  const [editBasicDetails, setEditBasicDetails] = useState(false)
  const [editLeadDetails, setEditLeadDetails] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main>
            <SideNav />

            <div className={common.main}>

              <div className={styles.header}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <h2>Lead Status</h2>
                  <h3>41653</h3>
                </div>
                <div>
               <div className={styles.headerProgress}>
                {items.map((item,index) => {
                   return  <div className={(index == 0 || index == 1 || index == 2) && styles.activeProgress}>
                   <span><BsCheck2 color="#fff" size={20} /></span>
                   <h2>{item}</h2>
                   <p>Nov 23, 2022 </p>
                   <p>14:30 PM</p>
                 </div>
                })}
            </div> 
          </div>
            </div>

            <div style={{backgroundColor:'#e6fbf2',borderColor:'#d3f2f3'}} className={styles.card}>
                <div className={styles.cardHeader}>
                  <h2>BASIC DETAILS</h2>
                  {!editBasicDetails ? <FiEdit onClick={()=>setEditBasicDetails(true)} color="#299EFE" size={22} /> : <div style={{display:'flex',alignItems:'center',gap:16}}>
                    <button onClick={()=>setEditBasicDetails(false)} className={styles.cancelBtn}>Cancel</button>
                    <button onClick={()=>setEditBasicDetails(false)} className={styles.saveBtn}>Save</button>
                    </div>}
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
                  <div>
                    <h3>Full Name</h3>
                    {editBasicDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Email</h3>
                    {editBasicDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Mobile</h3>
                    {editBasicDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
                  <div>
                    <h3>Lead Source</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                  <div>
                    <h3>Assigned To</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                  <div>
                    <h3>Status</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                </div>

                <div className={styles.cardSeparator}></div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginTop:28}}>
                  <div>
                    <h3>Lead Age</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                  <div>
                    <h3>Stage</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                  <div>
                    <h3>Alternate Mobile</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                </div>
            </div>


            <div style={{backgroundColor:'#EEF5F7',borderColor:'#dceef8'}} className={styles.card}>
                <div className={styles.cardHeader}>
                  <h2>LEAD DETAILS</h2>
                  {!editLeadDetails ? <FiEdit onClick={()=>setEditLeadDetails(true)} color="#299EFE" size={22} /> : <div style={{display:'flex',alignItems:'center',gap:16}}>
                    <button onClick={()=>setEditLeadDetails(false)} className={styles.cancelBtn}>Cancel</button>
                    <button onClick={()=>setEditLeadDetails(false)} className={styles.saveBtn}>Save</button>
                    </div>}
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
                  <div>
                    <h3>Company Name</h3>
                    {editLeadDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Company Website</h3>
                    {editLeadDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Address</h3>
                    {editLeadDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
                  <div>
                    <h3>Approx Timeline</h3>
                    {editLeadDetails ? <CustomDropdown white options={['option one','option two']} /> : <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Purpose of Office</h3>
                    {editLeadDetails ? <CustomDropdown white options={['option one','option two']} /> : <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Estimated Budget</h3>
                    {editLeadDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginBottom:28}}>
                  <div>
                    <h3>Area(Sq. Ft)</h3>
                    {editLeadDetails ? <Input white value="Lorem ipsum" /> :  <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Project Location</h3>
                    {editLeadDetails ? <CustomDropdown white options={['option one','option two']} /> : <h4>Lorem ipsum</h4>}
                  </div>
                  <div>
                    <h3>Scope of Work</h3>
                    {editLeadDetails ? <CustomDropdown white options={['option one','option two']} /> : <h4>Lorem ipsum</h4>}
                  </div>
                </div>

                <div className={styles.cardSeparator}></div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginTop:28}}>
                  <div>
                    <h3>Project Name</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                  <div>
                    <h3>Property Name</h3>
                    <h4>Lorem ipsum</h4>
                  </div>
                </div>

                <div style={{display:'grid',gridTemplateColumns:'28% 28% 28%',justifyContent:'space-between',alignItems:'center',marginTop:28}}>
                  <div>
                    <h3>Letter of Intent</h3>
                    <a href="#" download>Lorem ipsum <BiDownload size={18} color="#6DB4C4" /></a>
                  </div>
                  <div>
                    <h3>Agreement</h3>
                    <a href="#" download>Lorem ipsum <BiDownload size={18} color="#6DB4C4" /></a>
                  </div>
                  <div>
                    <h3>1st Payment</h3>
                    <a href="#" download>Lorem ipsum <BiDownload size={18} color="#6DB4C4" /></a>
                  </div>
                </div>
            </div>


            <div style={{backgroundColor:'#F0F8F4',borderColor:'#E8E8E8'}} className={styles.card}>
                <div className={styles.cardHeader} style={{marginBottom:16}}>
                  <h2>Tasks</h2>
                </div>
                <div className={styles.cardSeparator}></div>
                {tasks.map(i => {
                return <div className={styles.task}>
                <main>
                    <p className={styles.taskHeading}>
                      <HiOutlineUsers size={14} color="#a9d7fc" />
                      {i}
                    </p>
                    <div className={styles.taskDetails}>
                        <div>
                            <div>
                                <h2>Subject</h2>
                                <h3>Layout Planning</h3>
                            </div>
                            <div>
                                <h2>Location</h2>
                                <h3>Gurugram, Haryana</h3>
                            </div>
                        </div>
                        <div>
                            <div>
                                <h2>
                                Schedule
                                </h2>
                                <h3>
                                Nov 23, 2022 | 14:30 PM - 15:30 PM
                                </h3>
                            </div>
                        </div>
                    </div>
                </main>
                <aside>
                  <div />
                  <p className={styles.status}>
                     Upcoming
                  </p>
                </aside>
            </div>
            })}    
            </div>


            <div style={{backgroundColor:'#F6F7FC',borderColor:'#E8E8E8'}} className={styles.card}>
                <div className={styles.cardHeader} style={{marginBottom:16}}>
                  <h2>Recent Activities</h2>
                </div>
                <div className={styles.cardSeparator}></div>

            {Array(3).fill('').map(i => {
                return <div className={styles.activityContent}>
                <h2>SEP 2022</h2>
                <div className={styles.activityContentListItem}>
                    <div className={styles.icon}>
                        <HiOutlineDocumentText size={24} color="#707070" />
                    </div>
                    <div>
                        <h3>Sep 23</h3>
                        <h4>20:14 PM</h4>
                    </div>
                    <div className={styles.separator} />
                    <div>
                        <h5>Lead status changed from Query to lost by Sakshi</h5>
                    </div>
                </div>
                <div className={styles.activityContentListItem}>
                    <div className={styles.icon}>
                        <HiOutlineDocumentText size={24} color="#707070" />
                    </div>
                    <div>
                        <h3>Sep 23</h3>
                        <h4>20:14 PM</h4>
                    </div>
                    <div className={styles.separator} />
                    <div>
                        <h5>Lead Owner changed from Admin to Sakshi by System through Autotomation</h5>
                    </div>
                </div>
            </div>
            })}
  
            </div>





            </div>
        </main>
    </div>
  )
}
